import React from 'react';
import { Alert as TwAlert, Button, Typography } from "@material-tailwind/react";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { XMarkIcon } from "@heroicons/react/20/solid";

import { alertController } from "../Controllers/AlertController";

const Alert = observer(() => {
  const displaySecondaryText = () => {
    if (Array.isArray(alertController.secondaryText)) {
      return <>
        {alertController.secondaryText.map(line => <Typography color={alertController.getAlertTextColor()} className="mt-2 font-normal">
          {line}
        </Typography>)}
      </>
    }
    return <Typography
      color={alertController.getAlertTextColor()}
      className="mt-2 font-normal !text-xs md:!text-sm"
    >
      {alertController.secondaryText}
    </Typography>
  }

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        alertController.hideAlert()
      }}
      className={classNames("alert-root fixed z-[99999] m-auto w-fit top-0 xsm:top-12 left-0 right-0", { "invisible": !alertController.alertVisible })}>
      <TwAlert
        className={""}
        open={alertController.alertVisible}
        icon={<AlertIcon />}
        color={alertController.getAlertColor()}
        action={
          <Button
            variant="text"
            color="white"
            size="sm"
            className="!absolute top-2 right-0"
          >
            <XMarkIcon color={"black"} className="h-6 w-6" />
          </Button>
        }
      >
        <Typography
          variant="h6"
          color={alertController.getAlertTextColor()}
          className="!text-sm md:!text-base"
        >
          {alertController.mainText}
        </Typography>
        {alertController.secondaryText &&
          <>
            {displaySecondaryText()}
          </>
        }
      </TwAlert>
    </div>
  );
}
)

function AlertIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-6 w-6"
    >
      <path
        fillRule="evenodd"
        d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Alert